// Source: app/scripts/filters/filters.js
/* Filters */


Auction.filter('interpolate', ['version',
  function(version) {
    return function(text) {
      return String(text).replace(/\%VERSION\%/mg, version);
    };
  }
]).filter('fileSize', function() {
  return function(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while(fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  };
}).filter('shorten', function() {
  return function(value, len) {
    value = value || "";
    len = len || 50;
    if(value.length && value.length > len) {
      return value.substring(0, len) + "...";
    } else {
      return value;
    }
  };
}).filter('after', function(settings) {
  return function(dateString) {
    return moment(dateString, settings.dateFormats).isAfter();
  };
}).filter('fromNow', function() {
  return function(dateString) {
    return moment(dateString, settings.dateFormats).fromNow();
  };
}).filter('years', function() {
  return function(dateString) {
    return moment(settings.dateFormats).diff(moment(dateString, settings.dateFormats), 'years');
  };
}).filter('months', function() {
  return function(dateFrom, dateTo) {
    var m = moment(settings.dateFormats);
    if(dateTo) {
      m = moment(dateTo, settings.dateFormats);
    }
    return m.diff(moment(dateFrom, settings.dateFormats), 'months');
  };
}).filter('days', function() {
  return function(dateFrom, dateTo) {
    var m = moment(settings.dateFormats);
    if(dateTo) {
      m = moment(dateTo, settings.dateFormats);
    }
    return m.diff(moment(dateFrom, settings.dateFormats), 'days');
  };
}).filter('monthsToYears', function() {
  return function(months) {
    if(months >= 12) {
      var res = Math.floor(months / 12) + ' y';
      if(months % 12 != 0) {
        res = res + ' ' + months % 12 + ' m';
      }
      return res;
    } else {
      return months + ' m';
    }
  };
}).filter(
  'daysToYears', [
    '$filter',
    function($filter) {
      return function(days) {
        if(days >= 365) {
          var res = Math.floor(days / 365) + ' ' + $filter('translate')('generic.years');
          if(days % 365 != 0) {
            res = res + ' ' + days % 365 + ' ' + $filter('translate')('generic.days');
            ;
          }
          return res;
        } else {
          return days + ' ' + $filter('translate')('generic.days');
        }
      };
    }
  ])
  .filter('mDate', ['settings', function(settings) {
    return function(dateValue, format) {
      if (dateValue) {
        var momentObj;
        if (dateValue instanceof Date) {
          momentObj = moment(dateValue);
        } else {
          momentObj = moment(dateValue, settings.dateFormats);
        }

        if (momentObj.isValid()) {
          return momentObj.format(format || settings.dateFormat);
        } else {
          return "Invalid Date Format";
        }
      } else {
        return "";
      }
    };
  }]).filter('mDateTime', ['settings', function(settings) {
    return function(dateString, format) {
      if(dateString) {
        return moment(dateString, settings.dateFormats).format(format || settings.dateTimeFormat);
      }
      return null;
    };
  }]).filter('mTime', function() {
    return function(dateString) {
      if(dateString) {
        return moment(dateString, settings.dateFormats).format('HH:mm');
      }
      return null;
    };
  }).filter('hourMinutes', ['$filter',
    function($filter) {
      return function(minutes) {
        var mins = minutes % 60;
        var hours = (minutes - mins) / 60;
        return hours + ":" + ((mins >= 10) ? mins : "0" + mins);
      };
    }
  ]).filter('hourMinutesSeconds', ['$filter',
    function($filter) {
      return function(mils) {
        mils = Math.floor(mils / 1000);
        var secs = mils % 60;
        mils = (mils - secs) / 60;
        var mins = mils % 60;
        var hours = (mils - mins) / 60;
        var days = Math.floor(hours / 24);
        hours = hours % 24;
        return (days == 0 ? "" : days + "d " ) + (hours == 0 ? "" : hours + ":" ) + ((mins >= 10) ? mins : "0" + mins) + ":" + ((secs >= 10) ? secs : "0" + secs);
      };
    }
  ]).filter('jsonPath', function() {
    return function(v, path) {
      if(typeof path === 'function') {
        return path(v);
      }
      var fields = path.split('.');
      var x = v;
      for(var j in fields) {
        if(typeof x === 'undefined' || x === null) {
          break;
        }
        x = x[fields[j]];
      }
      return x;
    }
  }).
  filter('objectEval', function() {
    return function(v, path, join) {
      if(!path) {
        return [];
      }
      if(typeof path === 'function') {
        return path(v);
      }
      var result = [];
      var elems = path.split(' ');
      for(var i in elems) {
        var t = elems[i];
        var fields = t.split('.');
        var x = v;
        for(var j in fields) {
          if(typeof x === 'undefined') {
            break;
          }
          x = x[fields[j]];
        }
        result.push(x);
      }
      if(join) {
        return result.join(" ").trim();
      } else {
        return result;
      }
    };
  }).filter('serviceMethods', ['$injector',
    function($injector) {
      return function(path) {
        var result = [];
        var elems = path.split(' ');
        for(var i in elems) {
          var t = elems[i];
          var fields = t.split('.');

          var x = $injector.get(fields[0]);
          fields.shift();
          for(var j in fields) {
            if(typeof x === 'undefined') {
              break;
            }
            x = x[fields[j]];
          }
          result.push(x);
        }
        return result;
      };
    }
  ]).filter('employeeName', function() {
    return function(employee) {
      if(employee) {
        return employee.firstName + ' ' + employee.lastName;
      } else {
        return '';
      }

    };
  }).filter('range', function() {
    return function(input, total) {
      total = parseInt(total);
      for(var i = 0; i < total; i++)
        input.push(i);
      return input;
    };
  }).filter('numberFixedLen', function() {
    return function(n, len) {
      var num = parseInt(n, 10);
      len = parseInt(len, 10);
      if(isNaN(num) || isNaN(len)) {
        return n;
      }
      num = '' + num;
      while(num.length < len) {
        num = '0' + num;
      }
      return num;
    };
  }).filter('trust', [
    '$sce',
    function($sce) {
      return function(text) {
        if(typeof text === 'string') {
          return $sce.trustAsHtml(text);
        } else {
          return "";
        }

      };
    }
  ]).filter('markdown', function() {
    return function(text) {
      if(typeof text == "undefined") {
        return "";
      }
      var converter = new Showdown.converter({
        extensions: ['github', 'prettify', 'table', 'twitter']
      });
      return converter.makeHtml(text);
    };
  }).filter('marked', function() {
    return function(text, id) {
      if(typeof text == "undefined") {
        return "";
      }
      var m = marked;
      m.setOptions({
        renderer: new m.Renderer(),
        gfm: true,
        tables: true,
        breaks: false,
        pedantic: false,
        sanitize: true,
        smartLists: true,
        smartypants: false
      });
      return m(text);
    };
  }).filter('yesNo', function() {
    return function(choice) {
      if(typeof choice == "undefined") {
        return 'glyphicon glyphicon-question-sign';
      } else if(choice) {
        return 'glyphicon glyphicon-ok-sign';
      } else {
        return 'glyphicon glyphicon-remove-sign';
      }
    };
  }).filter('jsonPrettify', function() {
    return function(obj) {
      function replacer(k, v) {
        if(typeof v !== "object" && typeof v !== "Array") {
          var res = typeof v;
          return res;
        } else {
          return v;
        }
      }

      return JSON.stringify(obj, replacer, '  ');
    };
  }).filter('mfTranslate', ['$translate', function($translate) {
    return function(multilingualField, fieldName) {
      fieldName = fieldName || 'value';
      var lang = $translate.use() || $translate.proposedLanguage() || "";
      if(lang == 'gb') {
        lang = 'en';
      }

      multilingualField = multilingualField || {};
      return multilingualField[fieldName + lang.toUpperCase()];
    };
  }]).filter('password', ['$filter', function($filter) {
    var dot = String.fromCharCode(8226);
    return function(value) {
      if(typeof value === 'string') {
        return value.replace(/./g, dot);
      }
      return "";
    };
  }]).filter('fieldFormat', ['$filter', function($filter) {
    return function(value, type) {
      if(type == 'number') {
        return $filter('number')(value);
      }
      if(type == 'password') {
        return $filter('password')(value);
      }
      return value;
    };
  }]);
